var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { weightFormat } from '../../utils/format';
var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: 0;\n\n  li {\n    list-style-position: inside;\n    white-space: nowrap;\n  }\n"], ["\n  padding-left: 0;\n\n  li {\n    list-style-position: inside;\n    white-space: nowrap;\n  }\n"])));
var DeliveryRequestItemList = function (_a) {
    var deliveryRequest = _a.deliveryRequest;
    return (React.createElement(List, null, deliveryRequest.items.map(function (item) {
        var weight = parseFloat(item.warehouseItem.offer.bagSize) * item.quantity;
        return (React.createElement("li", { key: item.id },
            item.warehouseItem.offer.lotNumber,
            ": ",
            item.quantity,
            " (",
            weightFormat(weight),
            ")"));
    })));
};
export default DeliveryRequestItemList;
var templateObject_1;
